const COLORS = ["#f96424", "#ffb48a", "#ffd84d", "#1c1917", "#fff1e8", "#ff8a4c"];

type Shape = "asterisk" | "dot" | "strip";

function asterisk(ctx: CanvasRenderingContext2D, s: number) {
  ctx.lineWidth = s * 0.34;
  ctx.lineCap = "round";
  ctx.beginPath();
  for (const a of [Math.PI / 2, Math.PI / 6, -Math.PI / 6]) {
    const dx = Math.cos(a) * s;
    const dy = Math.sin(a) * s;
    ctx.moveTo(-dx, -dy);
    ctx.lineTo(dx, dy);
  }
  ctx.stroke();
}

/** A short burst from a point, drawn on a throwaway canvas over the page: little asterisks, dots and strips in the brand colours. */
function confetti(x = innerWidth / 2, y = innerHeight / 2, count = 70): void {
  const canvas = document.createElement("canvas");
  const dpr = devicePixelRatio || 1;
  canvas.style.cssText = "position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:100";
  canvas.width = innerWidth * dpr;
  canvas.height = innerHeight * dpr;
  document.body.append(canvas);
  const ctx = canvas.getContext("2d");
  if (!ctx) return canvas.remove();
  ctx.scale(dpr, dpr);
  const parts = Array.from({ length: count }, (_, i) => {
    const a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.15;
    const v = 7 + Math.random() * 8;
    const shape: Shape = i % 3 === 0 ? "asterisk" : i % 3 === 1 ? "strip" : "dot";
    return {
      x,
      y,
      vx: Math.cos(a) * v,
      vy: Math.sin(a) * v,
      r: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.35,
      s: shape === "asterisk" ? 5 + Math.random() * 4 : 3 + Math.random() * 3,
      shape,
      c: COLORS[i % COLORS.length]!,
    };
  });
  const start = performance.now();
  const frame = (t: number) => {
    const age = t - start;
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    ctx.globalAlpha = Math.max(0, 1 - Math.max(0, age - 900) / 450);
    for (const p of parts) {
      p.vy += 0.3;
      p.vx *= 0.985;
      p.x += p.vx;
      p.y += p.vy;
      p.r += p.vr;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.r);
      ctx.fillStyle = p.c;
      ctx.strokeStyle = p.c;
      if (p.shape === "asterisk") asterisk(ctx, p.s);
      else if (p.shape === "strip") ctx.fillRect(-p.s, -p.s / 2.5, p.s * 2, p.s / 1.25);
      else {
        ctx.beginPath();
        ctx.arc(0, 0, p.s * 0.8, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    }
    if (age < 1350) requestAnimationFrame(frame);
    else canvas.remove();
  };
  requestAnimationFrame(frame);
}

/** Bursts from the middle of an element, or the middle of the screen without one. */
export function confettiFrom(el: Element | null | undefined, count?: number): void {
  const r = el?.getBoundingClientRect();
  confetti(r ? r.left + r.width / 2 : undefined, r ? r.top + r.height / 2 : undefined, count);
}
